<prime-layout
  [title]="title"
  [subtitle]="subtitle"
  [titleClass]="titleClass"
  [logoSrc]="logoSrc"
  [logoClass]="logoClass"
  [headerButtonOptions]="headerButtonOptions"
></prime-layout>
